// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TJ-z","twoColumnImage":"UJ-z"};